import { render, staticRenderFns } from "./WhatsappLogin.vue?vue&type=template&id=13319baf&scoped=true"
import script from "./WhatsappLogin.vue?vue&type=script&lang=js"
export * from "./WhatsappLogin.vue?vue&type=script&lang=js"
import style0 from "./WhatsappLogin.vue?vue&type=style&index=0&id=13319baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13319baf",
  null
  
)

export default component.exports